import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const ListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 10,
  justifyContent: 'center',
  borderRadius: 5,
  width: '100%',
}));

export const ItemContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 15,
  border: theme.palette.type === 'dark' ? '1px solid #2d343e' : '1px solid #cdd9e9',
  borderRadius: 5,
  width: '100%',
  cursor: 'pointer',
  [theme.breakpoints.down(1000)]: {
    flexDirection: 'column',
    alignItems: 'unset',

    '& > div:not(:first-child)': {
      alignItems: 'unset',

      '& * p': {
        lineHeight: '1.4!important',
      },
    },
  },
}));

export const Left = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 15,

  '& > div > p': {
    lineHeight: 1.2,

    [theme.breakpoints.up(1000)]: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: 200,
      textOverflow: 'ellipsis',
    },
  },
}));

export const Middle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  '& > div ': {
    display: 'flex',
    justifyContent: 'space-between',
    width: 350,

    [theme.breakpoints.down(1000)]: {
      width: 'unset',
    },

    '& > p': {
      lineHeight: 1.2,
    },
  },
}));

export const Right = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: 100,
  alignItems: 'flex-end',

  '& > div > p': {
    lineHeight: 1.2,
  },

  '& p': {
    maxWidth: 100,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}));

export const CustomImage = styled('img')(({ theme }) => ({
  height: 44,
  width: 44,
  borderRadius: 5,
}));

export const FlexRightContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  justifyContent: 'flex-end',
  margin: '5px 0',

  [theme.breakpoints.down(1000)]: {
    justifyContent: 'unset',
  },

  '& svg': {
    width: 20,

    '& path': {
      fill: COLORS.PRIMARY,
    },
  },
}));
